import { render, staticRenderFns } from "./Botaccount.vue?vue&type=template&id=1e8d9618&scoped=true"
import script from "./Botaccount.vue?vue&type=script&lang=js"
export * from "./Botaccount.vue?vue&type=script&lang=js"
import style0 from "./Botaccount.vue?vue&type=style&index=0&id=1e8d9618&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e8d9618",
  null
  
)

export default component.exports